/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */
import { IMeasurementTypeObject, IObjectKeys } from './UnitModel';

export const measurementTypes: IMeasurementTypeObject[] = [
  {
    measurementType: ['electricity', 'electric'],
    units: {
      'watt hour': [
        {
          name: 'watt hour',
          symbol: 'Wh',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'Wh'
        },
        {
          name: 'kilowatt hour',
          symbol: 'kWh',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kWh'
        },
        {
          name: 'megawatt hour',
          symbol: 'MWh',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'MWh'
        },
        {
          name: 'gigawatt hour',
          symbol: 'GWh',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'GWh'
        },
        {
          name: 'terawatt hour',
          symbol: 'TWh',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TWh'
        }
      ],
      watt: [
        {
          name: 'watt',
          symbol: 'W',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'W'
        },
        {
          name: 'kilowatt',
          symbol: 'kW',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kW'
        },
        {
          name: 'megawatt',
          symbol: 'MW',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'MW'
        },
        {
          name: 'gigawatt',
          symbol: 'GW',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'GW'
        },
        {
          name: 'terawatt',
          symbol: 'TW',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TW'
        }
      ],
      'volt ampere': [
        {
          name: 'volt ampere',
          symbol: 'VA',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'VA'
        },
        {
          name: 'kilovolt ampere',
          symbol: 'kVA',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kVA'
        },
        {
          name: 'megavolt ampere',
          symbol: 'MVA',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'MVA'
        },
        {
          name: 'gigavolt ampere',
          symbol: 'GVA',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'GVA'
        },
        {
          name: 'terawattvolt ampere',
          symbol: 'TVA',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TVA'
        }
      ]
    }
  },
  {
    measurementType: ['carbon'],
    units: {
      'metric ton': [
        {
          name: 'metric ton',
          symbol: 'ton',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'tons'
        },
        {
          name: 'kilo ton',
          symbol: 'kton',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'ktons'
        },
        {
          name: 'million ton',
          symbol: 'Mton',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'Mtons'
        },
        {
          name: 'giga ton',
          symbol: 'Gton',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'Gtons'
        },
        {
          name: 'tera ton',
          symbol: 'Tton',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'Ttons'
        }
      ]
    }
  },
  {
    measurementType: ['water', 'sewerage', 'sewer'],
    units: {
      gallon: [
        {
          name: 'gallon',
          symbol: 'gal',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'gal'
        },
        {
          name: 'kilo gallon',
          symbol: 'kgal',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kgal'
        },
        {
          name: 'million gallon',
          symbol: 'Mgal',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'Mgal'
        },
        {
          name: 'giga gallon',
          symbol: 'Ggal',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'Ggal'
        },
        {
          name: 'tera gallon',
          symbol: 'Tgal',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'Tgal'
        }
      ],
      'centum cubic feet': [
        {
          name: 'centum cubic feet',
          symbol: 'Ccf',
          minValue: 0,
          maxValue: 9,
          displayUnit: 'Ccf'
        },
        {
          name: 'thousand cubic feet',
          symbol: 'Mcf',
          minValue: 10,
          maxValue: 9999,
          displayUnit: 'Mcf'
        },
        {
          name: 'million cubic feet',
          symbol: 'MMcf',
          minValue: 10000,
          maxValue: 9999999,
          displayUnit: 'MMcf'
        },
        {
          name: 'billion cubic feet',
          symbol: 'BCF',
          minValue: 10000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'BCF'
        }
      ],
      litre: [
        {
          name: 'litre',
          symbol: 'L',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'L'
        },
        {
          name: 'kilo litre',
          symbol: 'kL',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kL'
        },
        {
          name: 'million litre',
          symbol: 'ML',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'ML'
        },
        {
          name: 'giga litre',
          symbol: 'GL',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'GL'
        },
        {
          name: 'tera litre',
          symbol: 'TL',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TL'
        }
      ],
      'cubic meter': [
        {
          name: 'cubic meter',
          symbol: 'm3',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'm3'
        },
        {
          name: 'kilo cubic meter',
          symbol: 'km3',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'km3'
        },
        {
          name: 'million cubic meter',
          symbol: 'Mm3',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'Mm3'
        },
        {
          name: 'giga cubic meter',
          symbol: 'Gm3',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'Gm3'
        },
        {
          name: 'tera cubic meter',
          symbol: 'Tm3',
          minValue: 1000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'Tm3'
        }
      ]
    }
  },
  {
    measurementType: ['gas'],
    units: {
      therm: [
        {
          name: 'therm',
          symbol: 'thm',
          minValue: 0,
          maxValue: 9,
          displayUnit: 'thm'
        },
        {
          name: 'decatherms',
          symbol: 'Dth',
          minValue: 10,
          maxValue: 9999,
          displayUnit: 'Dth'
        },
        {
          name: 'kilo decatherms',
          symbol: 'K Dth',
          minValue: 10000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'K Dth'
        }
      ],
      millionbtu: [
        {
          name: 'millionbtu',
          symbol: 'MMBTU',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'MMBTU'
        },
        {
          name: 'kilo millionbtu',
          symbol: 'K MMBTU',
          minValue: 1000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'K MMBTU'
        }
      ],
      joules: [
        {
          name: 'joules',
          symbol: 'J',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'J'
        },
        {
          name: 'kilo joules',
          symbol: 'kJ',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kJ'
        },
        {
          name: 'mega joules',
          symbol: 'MJ',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'MJ'
        },
        {
          name: 'giga joules',
          symbol: 'GJ',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'GJ'
        },
        {
          name: 'tera joules',
          symbol: 'TJ',
          minValue: 1000000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TJ'
        }
      ],
      'centum cubic feet': [
        {
          name: 'centum cubic feet',
          symbol: 'Ccf',
          minValue: 0,
          maxValue: 9,
          displayUnit: 'Ccf'
        },
        {
          name: 'thousand cubic feet',
          symbol: 'Mcf',
          minValue: 10,
          maxValue: 9999,
          displayUnit: 'Mcf'
        },
        {
          name: 'million cubic feet',
          symbol: 'MMcf',
          minValue: 10000,
          maxValue: 9999999,
          displayUnit: 'MMcf'
        },
        {
          name: 'billion cubic feet',
          symbol: 'BCF',
          minValue: 10000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'BCF'
        }
      ],
      'standard cubic meter': [
        {
          name: 'standard cubic meter',
          symbol: 'Sm3',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'Sm3'
        },
        {
          name: 'kilo standard cubic meter',
          symbol: 'kSm3',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kSm3'
        },
        {
          name: 'million standard cubic meter',
          symbol: 'MSm3',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'MSm3'
        },
        {
          name: 'giga standard cubic meter',
          symbol: 'GSm3',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'GSm3'
        },
        {
          name: 'tera standard cubic meter',
          symbol: 'TSm3',
          minValue: 1000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TSm3'
        }
      ],
      'cubic meter': [
        {
          name: 'cubic meter',
          symbol: 'm3',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'm3'
        },
        {
          name: 'kilo cubic meter',
          symbol: 'km3',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'km3'
        },
        {
          name: 'million cubic meter',
          symbol: 'Mm3',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'Mm3'
        },
        {
          name: 'giga cubic meter',
          symbol: 'Gm3',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'Gm3'
        },
        {
          name: 'tera cubic meter',
          symbol: 'Tm3',
          minValue: 1000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'Tm3'
        }
      ],
      'normal cubic meter': [
        {
          name: 'normal cubic meter',
          symbol: 'Nm3',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'Nm3'
        },
        {
          name: 'kilo normal cubic meter',
          symbol: 'kNm3',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kNm3'
        },
        {
          name: 'million normal cubic meter',
          symbol: 'MNm3',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'MNm3'
        },
        {
          name: 'giga normal cubic meter',
          symbol: 'GNm3',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'GNm3'
        },
        {
          name: 'tera normal cubic meter',
          symbol: 'TNm3',
          minValue: 1000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TNm3'
        }
      ],
      btu: [
        {
          name: 'btu',
          symbol: 'BTU',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'BTU'
        },
        {
          name: 'thousand btu',
          symbol: 'kBTU',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kBTU'
        },
        {
          name: 'million btu',
          symbol: 'MMBTU',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'MMBTU'
        },
        {
          name: 'kilo million btu',
          symbol: 'K MMBTU',
          minValue: 1000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'K MMBTU'
        }
      ],
      'watt hour': [
        {
          name: 'watt hour',
          symbol: 'Wh',
          minValue: 0,
          maxValue: 999,
          displayUnit: 'Wh'
        },
        {
          name: 'kilowatt hour',
          symbol: 'kWh',
          minValue: 1000,
          maxValue: 999999,
          displayUnit: 'kWh'
        },
        {
          name: 'megawatt hour',
          symbol: 'MWh',
          minValue: 1000000,
          maxValue: 999999999,
          displayUnit: 'MWh'
        },
        {
          name: 'gigawatt hour',
          symbol: 'GWh',
          minValue: 1000000000,
          maxValue: 999999999999,
          displayUnit: 'GWh'
        },
        {
          name: 'terawatt hour',
          symbol: 'TWh',
          minValue: 1000000000,
          maxValue: Number.MAX_VALUE,
          displayUnit: 'TWh'
        }
      ]
    }
  }
];

export const responseUnitMapping: IObjectKeys = {
  'watt hour': 'watt hour',
  'kilowatt hour': 'watt hour',
  'megawatt hour': 'watt hour',
  'gigawatt hour': 'watt hour',
  'terawatt hour': 'watt hour',

  watt: 'watt',
  kilowatt: 'watt',
  megawatt: 'watt',
  gigawatt: 'watt',
  terawatt: 'watt',
  'kilovolt ampere': 'volt ampere',
  'volt ampere': 'volt ampere',

  'metric ton': 'metric ton',
  'kilo ton': 'metric ton',
  'million ton': 'metric ton',

  gallon: 'gallon',
  'kilo gallon': 'gallon',
  'million gallon': 'gallon',
  'giga gallon': 'gallon',
  'tera gallon': 'gallon',

  litre: 'litre',
  'kilo litre': 'litre',
  'million litre': 'litre',
  'giga litre': 'litre',
  'tera litre': 'litre',

  'centum cubic feet': 'centum cubic feet',
  'thousand cubic feet': 'centum cubic feet',
  'million cubic feet': 'centum cubic feet',
  'billion cubic feet': 'centum cubic feet',

  therm: 'therm',
  decatherms: 'therm',
  'kilo decatherms': 'therm',

  millionbtu: 'millionbtu',
  'kilo millionbtu': 'millionbtu',

  joules: 'joules',
  'kilo joules': 'joules',
  'mega joules': 'joules',
  'giga joules': 'joules',
  'tera joules': 'joules',

  'cubic meter': 'cubic meter',
  'kilo cubic meter': 'cubic meter',
  'million cubic meter': 'cubic meter',
  'giga cubic meter': 'cubic meter',
  'tera cubic meter': 'cubic meter',

  'standard cubic meter': 'standard cubic meter',
  'kilo standard cubic meter': 'standard cubic meter',
  'million standard cubic meter': 'standard cubic meter',
  'giga standard cubic meter': 'standard cubic meter',
  'tera standard cubic meter': 'standard cubic meter',

  'normal cubic meter': 'normal cubic meter',
  'kilo normal cubic meter': 'normal cubic meter',
  'million normal cubic meter': 'normal cubic meter',
  'giga normal cubic meter': 'normal cubic meter',
  'tera normal cubic meter': 'normal cubic meter',

  btu: 'btu',
  'thousand btu': 'btu',
  'million btu': 'btu',
  'kilo million btu': 'btu'
};
